import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPhoto = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.5 6.25C7.25736 6.25 6.25 7.25736 6.25 8.5C6.25 9.74264 7.25736 10.75 8.5 10.75C9.74264 10.75 10.75 9.74264 10.75 8.5C10.75 7.25736 9.74264 6.25 8.5 6.25ZM7.75 8.5C7.75 8.08579 8.08579 7.75 8.5 7.75C8.91421 7.75 9.25 8.08579 9.25 8.5C9.25 8.91421 8.91421 9.25 8.5 9.25C8.08579 9.25 7.75 8.91421 7.75 8.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.25 7C3.25 4.92893 4.92893 3.25 7 3.25H17C19.0711 3.25 20.75 4.92893 20.75 7V17C20.75 19.0711 19.0711 20.75 17 20.75H7C4.92893 20.75 3.25 19.0711 3.25 17V7ZM19.25 7V12.2265L18.1602 11.2762C16.6741 9.98029 14.4383 10.0566 13.044 11.4509L10.7526 13.7423C10.4597 14.0352 9.98479 14.0352 9.69189 13.7423L9.5001 13.5506C8.42616 12.4766 6.68495 12.4766 5.61101 13.5506L4.75 14.4116V7C4.75 5.75736 5.75736 4.75 7 4.75H17C18.2426 4.75 19.25 5.75736 19.25 7ZM4.75 17V16.5329L6.67167 14.6112C7.15983 14.1231 7.95128 14.1231 8.43944 14.6112L8.63123 14.803C9.50991 15.6817 10.9345 15.6817 11.8132 14.803L14.1047 12.5116C14.9412 11.675 16.2827 11.6292 17.1744 12.4067L19.25 14.2167V17C19.25 18.2426 18.2426 19.25 17 19.25H7C5.75736 19.25 4.75 18.2426 4.75 17Z",
		fill: "currentColor"
	})]
});
export { SvgIconPhoto as ReactComponent };
